export const config = {
  id: 'oregonTier2',
  path: '/oregon-tier-2',
  // Deprecated: keep config for redirects/IDs, but do not register a route.
  // appRedirectPath consolidates this path to /oregon-tier-1 (preserving query params).
  show: () => false,
};
